import React, { useState } from 'react';
import { Button } from 'reactstrap';
import GuestForm from './GuestForm';

export default function GuestFormButton({
    id, LoadData
}) {
    const [isUpdating, setIsUpdating] = useState(false);

    return (
        <div>
            <Button
                color="primary"
                size="sm"
                onClick={() => setIsUpdating(!isUpdating)}
            >
                Edit
      </Button>
            {isUpdating && (
                <GuestForm
                    id={id}
                    toggleModal={() => {
                        setIsUpdating(!isUpdating);
                    }}
                    formLabel="Edit Guest Information"
                    visible={isUpdating}
                    LoadData={LoadData}
                />
            )}
        </div>
    );
}

